export default {
  AdminEvidenceIsPublicCheckbox: 'AdminEvidenceIsPublicCheckbox',
};

